<template>
    <div class="local-scroller padding-right-5 card-col">
        <div v-if="dataSpellingCurrent.length === 0">
            <h4 class="margin-top-15" style="text-align: center; color: #c5c0c0;">Không có lỗi chính tả</h4>
        </div>
        <div v-else>
            <div v-if="!isShowDetail">
                <SpellingCard v-for="(spelling_result, index) in dataSpellingCurrent"
                              :key="spelling_result.page"
                              :spelling_result="spelling_result"
                              :index="index+1">
                </SpellingCard>
            </div>
            <div v-else>
                <el-row>
                    <el-col :span="8">
                        <el-button type="text" icon="el-icon-back" @click="disablePageDetail">Trở về</el-button>
                    </el-col>
                    <el-col :span="16">
                        <el-button type="text" icon="el-icon-arrow-left" class="margin-left-25"
                                   :disabled="currentPageDetail === parseInt(dataSpellingCurrent[0].page)"
                                   @click="updateCurrentPage(parseInt(dataSpellingCurrent[getIndex(dataSpellingCurrent) - 1].page))"></el-button>
                        <span class="margin-left-15 margin-right-15">Trang {{currentPageDetail}}</span>
                        <el-button type="text" icon="el-icon-arrow-right"
                                   :disabled="currentPageDetail === parseInt(dataSpellingCurrent[dataSpellingCurrent.length - 1].page)"
                                   @click="updateCurrentPage(parseInt(dataSpellingCurrent[getIndex(dataSpellingCurrent) + 1].page))"></el-button>
                    </el-col>
                </el-row>
                <div v-for="(spelling_detail, index) in getCurrentMistakes(dataSpellingCurrent)" :key="index">
                    <SpellingCardDetail :spelling_detail="spelling_detail" :index="index + 1"
                                        :id="'spelling-detail-card-' + currentPageDetail + '-' + index"></SpellingCardDetail>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SpellingCard from './SpellingCard'
import SpellingCardDetail from './SpellingCardDetail'

export default {
    name: 'SpellErrorList',
    components: {
        SpellingCard,
        SpellingCardDetail
    },
    methods: {
        getIndex(dataSpellingCurrent) {
            return dataSpellingCurrent.findIndex((ele) => parseInt(ele.page) === this.currentPageDetail)
        },
        getCurrentMistakes(dataSpellingCurrent) {
            return dataSpellingCurrent[this.getIndex(dataSpellingCurrent)].mistakes
        },
        disablePageDetail() {
            this.$store.dispatch('docRes/spelling/updateCurrentSpellingTooltip', -1)
            this.$store.dispatch('docRes/spelling/updateCurrentSpellingPageDetail', 0)
            this.$store.dispatch('docRes/spelling/updateIsShowSpellingPageDetail', false)
        },
        updateCurrentPage(page) {
            this.$store.dispatch('docRes/spelling/updateCurrentSpellingTooltip', -1)
            this.$store.dispatch('docRes/spelling/updateCurrentSpellingPageDetail', page)

            document
            // .getElementById(`selectorSpellingResult-${pageCurrent}-0`)
                .getElementById(`page-${this.currentPageDetail}`)
                .scrollIntoView({
                    behavior: 'auto',
                    inline: 'center',
                    block: 'start'
                })
            document
                .getElementById(`page-preview-${this.currentPageDetail}`)
                .scrollIntoView({
                    behavior: 'auto',
                    inline: 'center',
                    block: 'center'
                })
        }
    },
    mounted() {
    },
    computed: {
        dataSpellingCurrent() {
            return this.$store.getters['docRes/spelling/dataSpellingCurrent']
        },
        isShowDetail() {
            return this.$store.getters['docRes/spelling/isShowSpellingPageDetail']
        },
        currentPageDetail() {
            return this.$store.getters['docRes/spelling/currentSpellingPageDetail']
        }
    }
}
</script>

<style scoped>
.card-col {
    height: 100%;
}
</style>
